<template>
  <div class="mods-guide">
    <transition name="scale-in" @after-leave="closeDialog">
      <div v-if="showContent" class="container">
        <div class="container-wrapper">
          <div class="title">{{ languages.feedback }}</div>
          <div class="options" v-touchActive>
            <em class="before-icon mods"></em>
            <p @click="openMods" class="desc j-mods-guide-mods">{{ languages.passAskMods }}</p>
            <em class="after-icon"></em>
          </div>
          <p class="tips">{{ languages.passAskModsTip }}</p>
          <div class="options" v-touchActive>
            <em class="before-icon service"></em>
            <p @click="openService" class="desc j-mods-guide-service">{{ languages.passService }}</p>
            <em class="after-icon"></em>
          </div>
          <p class="tips">{{ languages.passServiceTip }}</p>
        </div>
        <div class="close-btn account" @click="hideContent"></div>
      </div>
    </transition>
    <transition name="fade-in">
      <div v-if="showContent" @click="hideContent" class="bg"></div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ['languages'],
  data() {
    return {
      showContent: false,
      operateType: ''
    };
  },
  methods: {
    closeDialog() {
      if (this.operateType === 'openMods') {
        this.$emit('openMods');
      }
      if (this.operateType === 'openService') {
        this.$emit('openService');
      }
      this.$emit('closePopup');
    },
    hideContent() {
      this.showContent = false;
    },
    openMods() {
      this.operateType = 'openMods';
      this.hideContent();
    },
    openService() {
      this.operateType = 'openService';
      this.hideContent();
    }
  },
  mounted() {
    this.showContent = true;
  },
  beforeDestroy() {
    this.showContent = false;
    window.setHasGlobalDialog(false)
  },
  created() {
    window.setHasGlobalDialog(true)
    window.globalHideDialogCb = this.hideContent
  },
};
</script>

<style scoped lang="scss">
$dialogW: 550px;
$dialogH: 308px;
.mods-guide {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.container {
  position: relative;
  width: $dialogW;
  min-height: $dialogH;
  background: white;
  z-index: 10;
}
.container-wrapper {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 14px;
  box-sizing: border-box;
}

.title {
  font-size: 23.6px;
  text-align: center;
  color: #414141;
  margin-top: 25px;
  margin-bottom: 25px;
}
.options {
  position: relative;
  padding-right: 48px;
  padding-left: 76px;
  width: 100%;
  line-height: 80px;
  box-sizing: border-box;
  margin-bottom: 5px;
  height: 95px;
  display: flex;
  align-items: center;
  background: #f3f3f3;
  .before-icon {
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    margin-right: 10px;
    float: left;
    width: 78px;
    height: 95px;
    background-image: url('../../assets/image/icons/token-icon.png');
    background-repeat: no-repeat;
    background-size: auto;
    background-position: center center;
    &.service {
      background-image: url('../../assets/image/icons/user-icon.png');
    }
  }
  .after-icon {
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    float: right;
    margin: auto;
    margin-right: 30px;
    width: 11px;
    height: 18px;
    background: url('../../assets/image/icons/show-detail.png') no-repeat;
    background-size: 100% 100%;
  }
  .desc {
    width: 100%;
    font-size: 24px;
    height: 95px;
    line-height: 95px;
  }
}
.tips {
  font-size: 20px;
  color: #525252;
  text-align: center;
  margin-bottom: 30px;
}

.bg {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
}

.is-blancozone {
  .container,
  .container-wrapper {
    border-radius: 10px;
  }
  .options {
    background: #e9f4ff;
    .before-icon {
      background-image: url('../../assets/image/icons/token-icon-blue.png');

      &.service {
        background-image: url('../../assets/image/icons/user-icon-blue.png');
      }
    }
    .after-icon {
      width: 11px;
      height: 18px;
      background: url('../../assets/image/icons/selectHili.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}

@media screen and (orientation: landscape) {
  .container {
    transform: scale(0.7);
  }
}
</style>
